import CompaniesContainer from '../containers/CompaniesContainer';
import CompaniesContextProvider from '../contexts/companies.context';

const Companies = () => (
  <CompaniesContextProvider>
    <CompaniesContainer />
  </CompaniesContextProvider>
);
export default Companies;
